/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseContentPageTransitionOptions
 */
export interface DatabaseContentPageTransitionOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContentPageTransitionOptions
     */
    autoTransition?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseContentPageTransitionOptions
     */
    delay?: number;
}

/**
 * Check if a given object implements the DatabaseContentPageTransitionOptions interface.
 */
export function instanceOfDatabaseContentPageTransitionOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseContentPageTransitionOptionsFromJSON(json: any): DatabaseContentPageTransitionOptions {
    return DatabaseContentPageTransitionOptionsFromJSONTyped(json, false);
}

export function DatabaseContentPageTransitionOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseContentPageTransitionOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoTransition': !exists(json, 'autoTransition') ? undefined : json['autoTransition'],
        'delay': !exists(json, 'delay') ? undefined : json['delay'],
    };
}

export function DatabaseContentPageTransitionOptionsToJSON(value?: DatabaseContentPageTransitionOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autoTransition': value.autoTransition,
        'delay': value.delay,
    };
}

